/* eslint-disable max-len, space-in-parens */
export const ignoreErrors = [
  'Request failed with status code 401',
  'Request failed with status code 403',
];

